import { environment } from '@environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class StartAnalysisIcrService {
    // eslint-disable-next-line
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    sendIcr(icrData) {
        return this.httpClient.post(environment.api.base + 'icrs', icrData);
    }
}
StartAnalysisIcrService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function StartAnalysisIcrService_Factory() { return new StartAnalysisIcrService(i0.ɵɵinject(i1.HttpClient)); }, token: StartAnalysisIcrService, providedIn: "root" });
